module.exports = __webpack_public_path__ + "static/media/symmetry-website.fadeac45.png";